import { IDoorSizeOption, DoorSizeOption } from '../../common/door-size-option';
import { IProductTexture, ProductTexture } from '../../common/product-texture';
import { IProductReview, ProductReview } from '../../common/product-review';
import { DoorRecommendation } from '../../common/door-recommendation';

export interface IStormDoorModel {
    id: string;
    brand: string;
    description: string;
    doorSize: IDoorSizeOption;
    imageUrls: string[];
    flipbookPages: string[];
    sellingPoints: string[];
    textureVariants: IProductTexture[];
    price: number;
    productReview: IProductReview;
    complete: boolean;
    recommendation: DoorRecommendation;
    rating: number;
}


export class StormDoorModel implements IStormDoorModel {
    public id: string = '';
    public brand: string = '';
    public description: string = '';
    public doorSize: IDoorSizeOption = new DoorSizeOption();
    public imageUrls: string[] = [];
    public flipbookPages: string[] = [];
    public sellingPoints: string[] = [];
    public textureVariants: IProductTexture[] = [];
    public price: number = 0;
    public productReview: IProductReview = new ProductReview();
    public complete: boolean = false;
    public recommendation: DoorRecommendation = DoorRecommendation.Standard;
    public rating: number = 0;
}


